import { HomeHero } from '@/components/hero/HomeHero';

export const MainHydrateFallback = () => {
  return <HomeHero scrollTo="configuration" isLoading />;
};
